import React, { useState } from 'react';
import { APP_CONFIG, PRODUCT_SELECTION_HEADING, COMPANY_NAME_PREFIX } from '../../app-constants';
import {
  getProductNameText,
  getCidnValue,
  getDecryptedText,
  getCurrentProduct,
  closeOffPreviousProductLiveChat,
  showHideElement,
  getAuthorizationAccessToken,
  getEventRouteAndUserHashDetails,
} from '../../app-actions';
import FormSelectField from '../../components/form/select-field';
import Button from '../../components/button/button';
import { Desktop, Mobile } from '../../app-responsive';
import Modal from '../../components/modal';
import { customStylesDesktop, customStylesMobile } from '../../components/business-case-delete-modal/modal-styles-config';
import { getProductSelectionForAccount } from '../../authorable-content/authorable-content.actions';

export const formatUrl = route => `${APP_CONFIG.reactBasePath + route}/`;
const BusinessSolutionNavView = (props) => {
  const {
    authenticated,
    secureAuthenticated,
    cipLoginUrl,
    cipLogoutUrl,
    customerName,
    customerNameSecureAuth,
    productSelectionList,
    uCidnSelectionList,
    productError,
  } = props;
  const { clearSessionStorage } = props.actions;
  const errorLinkPresent = window.location.href.includes('error');
  const eventRouteDetails = getEventRouteAndUserHashDetails();
  const productTypes = errorLinkPresent === false && productError === false && eventRouteDetails.isPartnerView === false ?
    window.parent.tcom.researchInsights.appConfig.productType.split(',') : [];
  const productSelectionOptions = productTypes.map(product => (
    {
      key: product,
      value: getProductNameText(product),
    }
  ));

  const cidnListOptions = uCidnSelectionList.map((cidnItem) => {
    const cidnValue = getDecryptedText(cidnItem.encryptedCidn);
    return {
      key: cidnItem.encryptedCidn,
      value: `${COMPANY_NAME_PREFIX} ${cidnItem.accountName} (${cidnValue})`,
    };
  });

  const productSelectionValue = getCurrentProduct();
  const productSelectionText = getProductNameText(productSelectionValue);

  const currentAccountValue = window.parent.tcom.researchInsights.appConfig.currentAccount;

  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [modalIsOpenForAccount, setModalIsOpenForAccount] = useState(false);
  const [productSelection, setProductSelection] = useState(productSelectionValue);
  const [accountSelection, setAccountSelection] = useState(currentAccountValue);
  const [showAccountSelection, setShowAccountSelection] = useState(false);
  const [productSelectionChangeList, setProductSelectionChangeList] = useState([]);

  const currentAccountText = getCidnValue(accountSelection, uCidnSelectionList, true);

  const onProductSelectionBlur = (event) => {
    if (productSelectionValue !== event.target.value) {
      setProductSelection(event.target.value);
      window.tcom.researchInsights.appConfig.currentProduct = event.target.value;
      setModalIsOpen(true);
    }
  };

  const onProductSelection = (product) => {
    const { LoadNewSelectedProduct } = props.actions;
    LoadNewSelectedProduct({ productType: product });
  };

  const getProductCount = () => {
    if (window.tcom.researchInsights.appConfig.productType !== undefined) {
      return window.tcom.researchInsights.appConfig.productType.split(',').length;
    }
    return productSelectionList.length;
  };

  const onAccountSelectionBlur = (event) => {
    if (window.tcom.researchInsights.appConfig.currentAccount !== event.target.value) {
      sessionStorage.setItem('newAccountValue', event.target.value);
      setModalIsOpenForAccount(true);
    }
  };

  const onAccountSelectionFinalized = (newAccountValue) => {
    window.parent.tcom.researchInsights.appConfig.currentAccount = newAccountValue;
    setAccountSelection(newAccountValue);
    const bearerToken = getAuthorizationAccessToken();
    if (bearerToken !== 'Bearer undefined') {
      getProductSelectionForAccount(newAccountValue).then((responseData) => {
        const productData = responseData.data.productType;
        window.parent.tcom.researchInsights.appConfig.productType = responseData.data.productType.join();
        if (productData.length === 1) {
          setProductSelection(productData[0]);
          const { LoadNewSelectedProduct } = props.actions;
          LoadNewSelectedProduct({ productType: productData[0] });
          setProductSelectionChangeList([]);
          setModalIsOpenForAccount(false);
        } else {
          setShowAccountSelection(true);
          setProductSelection(null);
          setProductSelectionChangeList(productData);
          setModalIsOpenForAccount(true);
        }
      });
    } else {
      setTimeout(() => {
        getProductSelectionForAccount(newAccountValue).then((responseData) => {
          const productData = responseData.data.productType;
          window.parent.tcom.researchInsights.appConfig.productType = responseData.data.productType.join();
          if (productData.length === 1) {
            setProductSelection(productData[0]);
            const { LoadNewSelectedProduct } = props.actions;
            LoadNewSelectedProduct({ productType: productData[0] });
            setProductSelectionChangeList([]);
            setModalIsOpenForAccount(false);
          } else {
            setShowAccountSelection(true);
            setProductSelection(null);
            setProductSelectionChangeList(productData);
            setModalIsOpenForAccount(true);
          }
        });
      }, 5000);
    }
  };


  const onLoadDifferentProduct = () => {
    const { LoadNewSelectedProduct } = props.actions;
    setModalIsOpen(false);
    closeOffPreviousProductLiveChat();
    LoadNewSelectedProduct({ productType: productSelection });
  };

  const onLoadDifferentAccountYes = () => {
    showHideElement(false, 'ri-right-hand-nav');
    const newAccountValue = sessionStorage.getItem('newAccountValue');
    onAccountSelectionFinalized(newAccountValue);
  };

  const onLoadDifferentAccountNo = () => {
    setAccountSelection(window.tcom.researchInsights.appConfig.currentAccount);
    setModalIsOpenForAccount(false);
  };

  const productListContentChange = productSelectionChangeList.map(product => (
    <div className="row product-selection-row text-center" key={product}>
      <div className="col-12">
        <Button
          className="button do-business"
          buttonText={getProductNameText(product)}
          onClick={() => onProductSelection(product)}
        />
      </div>
    </div>
  ));

  const desktopModalStyles = { content: { ...customStylesDesktop.content, width: '50%' } };

  const modalContent = customStyles => (
    <Modal
      isOpen={modalIsOpen}
      style={customStyles}
      onRequestClose={() => setModalIsOpen(false)}
    >
      <div className="row">
        <div className="col-12">
          <h2>Product selection changing</h2>
        </div>
        <div className="col-12">
          <p>Kindly ensure that you have saved your data for the current product. Are you sure you want to proceed to different product</p>
        </div>
        <div className="col-6 text-right">
          <Button
            className="button clear"
            buttonText="No"
            onClick={() => setModalIsOpen(false)}
          />
        </div>
        <div className="col-6 text-left">
          <Button
            className="button do-business"
            buttonText="Yes"
            onClick={() => onLoadDifferentProduct()}
          />
        </div>
      </div>
    </Modal>
  );

  const accountChangeModalContent = customStyles => (
    <Modal
      isOpen={modalIsOpenForAccount}
      style={customStyles}
    >
      <React.Fragment>
        <div className={`row ${showAccountSelection === false ? '' : 'd-none'}`}>
          <div className="col-12">
            <h2>Account selection changing</h2>
          </div>
          <div className="col-12">
            <p>Kindly ensure that you have saved your data for the current account. Are you sure you want to proceed to different account</p>
          </div>
          <div className="col-6 text-right">
            <Button
              className="button clear"
              buttonText="No"
              onClick={() => onLoadDifferentAccountNo()}
            />
          </div>
          <div className="col-6 text-left">
            <Button
              className="button do-business"
              buttonText="Yes"
              onClick={() => onLoadDifferentAccountYes()}
            />
          </div>
        </div>
        <div className={`${showAccountSelection ? '' : 'd-none'}`}>
          <h2 className="text-center">{getCidnValue(accountSelection, uCidnSelectionList)}</h2>
        </div>
        <div className={`${showAccountSelection ? '' : 'd-none'}`}>
          <h2 className="text-center">{PRODUCT_SELECTION_HEADING}</h2>
          {productListContentChange}
        </div>
      </React.Fragment>
    </Modal>
  );

  const temporaryLogoutButton = (
    <li className="nav-item" key="logout">
      <button className="nav-link logout" onClick={() => clearSessionStorage(cipLogoutUrl)}>
        <i className="td-icon d-sm-none icon-lock" />
        Log out
      </button>
    </li>
  );
  const unauthenticatedRightNav = (
    <li className="nav-item">
      <a
        className={`nav-link login ${authenticated && 'link-arrow'}`}
        href={`${cipLoginUrl}`}
      >
        Login</a>
    </li>);

  // custom nav settings
  const loginNavItem = (
    <li className="nav-item">
      <label htmlFor="menu-toggle" className="nav-link disabled nav-title login icon-large link-arrow-mobile" aria-disabled>
        {eventRouteDetails.isPartnerView ? customerNameSecureAuth : customerName}
      </label>
    </li>
  );
  const authenticatedRightNav = (
    <React.Fragment>
      {loginNavItem}
      {uCidnSelectionList.length > 1 && (
        <li className="nav-item">
          <FormSelectField
            id="account-selection-change"
            disabled={false}
            onBlur={onAccountSelectionBlur}
            options={cidnListOptions}
            placeholder=""
            value={currentAccountText}
            sendKeyValueOnChange
            initialValuePresent
            showScrollBar
            searchCapable
          />
        </li>
      )}
      {getProductCount() > 1 && (
        <li className="nav-item">
          <FormSelectField
            id="product-selection-change"
            disabled={false}
            onBlur={onProductSelectionBlur}
            options={productSelectionOptions}
            placeholder=""
            value={productSelectionText}
            sendKeyValueOnChange
            initialValuePresent
          />
        </li>
      )}

      {eventRouteDetails.isPartnerView === false ? temporaryLogoutButton : ''}
    </React.Fragment>
  );
  const rightNav = authenticated || secureAuthenticated ? authenticatedRightNav : unauthenticatedRightNav;
  return (
    <React.Fragment>
      <div className="business-solution-nav-wrapper">
        <div className="root-container container">
          <div
            className={`nav business-solution-nav ${authenticated || secureAuthenticated ? 'authenticated flex-column flex-sm-row' : 'flex-row'}`}
          >
            <ul
              id="ri-right-hand-nav"
              className={`nav ${authenticated || secureAuthenticated ? 'order-first order-sm-last ml-sm-auto' : 'flex-row ml-auto'} right-hand-nav`}
            >
              {errorLinkPresent ? temporaryLogoutButton : rightNav}
            </ul>
          </div>
        </div>
      </div>
      <Mobile>
        {modalContent(customStylesMobile)}
        {accountChangeModalContent(customStylesMobile)}
      </Mobile>
      <Desktop>
        {modalContent(desktopModalStyles)}
        {accountChangeModalContent(desktopModalStyles)}
      </Desktop>
    </React.Fragment>
  );
};

export default BusinessSolutionNavView;
